import { OLMSApiService } from '@/shared/apis'
import { createAsyncThunk, EntityId } from '@reduxjs/toolkit'

import { DropdownOption } from '../models/DropdownOption'
import { dropdownSettings, DropdownSettingsKey } from '../models/DropdownSettings'

type ApiDropdownResponse = {
  id: EntityId
  name: string

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
} & Record<DropdownSettingsKey, any>

export const fetchDropdownData = createAsyncThunk(
  'dropdowns/fetchDropdownData',
  async (dropdownName: DropdownSettingsKey) => {
    const settings = dropdownSettings[dropdownName]

    if (!settings?.url) {
      throw new Error(`No URL configured for dropdown: ${dropdownName}`)
    }

    const response = await OLMSApiService.get<ApiDropdownResponse[]>(settings.url)

    const dropdownOptions: DropdownOption[] = response?.map(res => ({
      ...res,
      value: res.id,
      label: res.name,
    })) || []
    
    return {
      name: dropdownName,
      options: dropdownOptions,
    }
  },
)
